import { bffContactUs } from "../../../service";
import Types from "./types";

const quack = () => ({
    type: Types.QUACK
});

const submitContactUsQueryRequest = () => ({
    type: Types.SUBMIT_CONTACT_US_QUERY
});

// const submitContactUs = (name, email, query) => (dispatch) => {
//     dispatch(submitContactUsQueryRequest());
//     // const payload = {
//     //     type: "contact_us",
//     //     data: { name, email, query }
//     // };
//     const payload = {
//         "type": "contact_us",
//         "data": {
//             "to": ["hello.au@cars24.com"],
//             "addressType": "EMAIL",
//             "countryCode": X_COUNTRY_CODE.AU,
//             "variables": { name, email, query }
//         }
//     };
//     return new Promise((resolve, reject) => {
//         ThirdPartyService.b2cBuyerNotification(payload).then(response => {
//             resolve(response.data);
//         }).catch(error => {
//             reject(error);
//         });
//     });
// };

const submitContactUsViaHubSpot = (payload) => (dispatch) => {
    dispatch(submitContactUsQueryRequest());
    // const payload = {
    //     type: "contact_us",
    //     data: { name, email, query }
    // };
    return new Promise((resolve, reject) => {
        bffContactUs.submitContactQuery(payload).then(response => {
            resolve(response.data);
        }).catch(error => {
            reject(error);
        });
    });
};

export {
    quack,
    // submitContactUs,
    submitContactUsViaHubSpot as submitContactUs
};
